import { rtkQueryApiServices } from "../../services/api";

export const analyticsApis = rtkQueryApiServices.injectEndpoints({
  endpoints: (builder) => ({
    getVolunteerBreakDown: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/volunteer-breakdown",
        params,
      }),
    }),

    getVolunteerOverview: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/volunteer-overview",
        params,
      }),
    }),

    getTrainedVolunteers: builder.query({
      query: (year) => `reports/analytics/trained-volunteers?year=${year}`,
    }),

    getVolunteerPerByCategory: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/volunteer-percentage-by-category/",
        params,
      }),
    }),

    getConversionTracking: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/conversion-tracking/",
        params,
      }),
    }),

    getTrainingFunnelReadiness: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/training-funnel-readiness/",
        params,
      }),
    }),

    getUserCateogryBreakdown: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/user-category-breakdown/",
        params,
      }),
    }),

    getMonthlySignupBreakdown: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/monthly-signup-breakdown/",
        params,
      }),
    }),

    getUserDistributionBreakdown: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/user-distribution-breakdown/",
        params,
      }),
    }),

    getEquipmentInventory: builder.query({
      query: (params) => {
        return {
          url: "reports/analytics/equipment-inventory-summary",
          params,
        };
      },
    }),

    getEquipmentOwnershipBreakdown: builder.query({
      query: (params) => {

        return {
          url: "reports/analytics/equipment-ownership-breakdown/",
          params,
        };
      },
    }),

    getEquipmentStatusAnalytics: builder.query({
      query: (params) => {
        return {
          url: "reports/analytics/equipment-status",
          params,
        };
      },
    }),

    getStaffFieldSessionAvailability: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/staff-field-session-availability/",
        params,
      }),
    }),

    getMobileMaintenanceOutDaysAnalytics: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/vehicle-maintenance-monthly-out-days/",
        params,
      }),
    }),

    getVehicleMaintenanceUnits: builder.query({
      query: () => "reports/analytics/vehicle-maintenance-units",
    }),

    getMobileClinicNotMaintainedAnalytics: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/vehicle-maintenance-compliance/",
        params,
      }),
    }),

    getBillableVisitsAnalytics: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/billable-visits-breakdown/",
        params,
      }),
    }),

    getBillableEventsAnalytics: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/billable-events-breakdown/",
        params,
      }),
    }),

    getPatientsSeenPerEventAnalytics: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/patients-seen-per-event-breakdown/",
        params,
      }),
    }),

    getEventsTrendBreakdown: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/events-trend-breakdown/",
        params,
      }),
    }),

    getCancelledEventsBreakdown: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/cancelled-events-breakdown/",
        params,
      }),
    }),

    getDeploymentSuccessRateAnalytics: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/deployment-success-rate-breakdown/",
        params,
      }),
    }),

    getCapacityUtilizationAnalytics: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/capacity-utilization-breakdown/",
        params,
      }),
    }),

    getStaffingSlaBreakdown: builder.query({
      query: (params = {}) => ({
        url: "reports/analytics/staffing-sla-breakdown/",
        params,
      }),
    }),
  }),
});

export const {
  useGetVolunteerBreakDownQuery,
  useGetConversionTrackingQuery,
  useGetVolunteerOverviewQuery,
  useGetTrainedVolunteersQuery,
  useGetEquipmentInventoryQuery,
  useGetVolunteerPerByCategoryQuery,
  useGetEquipmentStatusAnalyticsQuery,
  useGetEquipmentOwnershipBreakdownQuery,
  useGetTrainingFunnelReadinessQuery,
  useGetUserCateogryBreakdownQuery,
  useGetMonthlySignupBreakdownQuery,
  useGetUserDistributionBreakdownQuery,
  useGetStaffFieldSessionAvailabilityQuery,
  useGetMobileMaintenanceOutDaysAnalyticsQuery,
  useGetVehicleMaintenanceUnitsQuery,
  useGetMobileClinicNotMaintainedAnalyticsQuery,
  useGetBillableVisitsAnalyticsQuery,
  useGetBillableEventsAnalyticsQuery,
  useGetPatientsSeenPerEventAnalyticsQuery,
  useGetEventsTrendBreakdownQuery,
  useGetCancelledEventsBreakdownQuery,
  useGetDeploymentSuccessRateAnalyticsQuery,
  useGetCapacityUtilizationAnalyticsQuery,
  useGetStaffingSlaBreakdownQuery,
} = analyticsApis;
